import React from 'react'
import Grid from '@material-ui/core/Grid'
import { useStyle } from './Style'
import ButtonInc from '../../../../../shared-ui/ButtonInc'
import { hasAuthourity } from '../../../../../lib/access.es6'
import { ClaimActionEnum } from '../../../lib/enum'

// Where an OMK rejection waits. The claim is still active and editable here, so
// the processing details can be corrected before the rejection is either undone
// or made final — `reject` deactivates the claim and notifies the customer, and
// nothing in the service can reopen it after that.
const RejectedPending = props => {
  const [toggleLoading, setToggleLoading] = React.useState('btn1')
  const classes = useStyle()
  const rejectionReason = props.claim.rejection_reason

  const handleReconfirmClaim = () => {
    setToggleLoading('btn1')
    props.submitClaimAction({
      claim_action: ClaimActionEnum.confirm,
      claim_guid: props.claim.guid
    })
  }

  // The reason captured at rejection stands; the service keeps it when the body
  // omits one.
  const handleConfirmRejection = () => {
    setToggleLoading('btn2')
    props.submitClaimAction({
      claim_action: ClaimActionEnum.reject,
      claim_guid: props.claim.guid
    })
  }

  return (
    <section className={classes.ClaimActionButtons}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <p style={{ textAlign: 'center' }}>
            Claim is rejected, awaiting confirmation. Reconfirm it to send it
            back to Decision Pending, or confirm the rejection to finalise it.
          </p>
        </Grid>
        {rejectionReason && (
          <Grid item xs={12} sm={12} md={12}>
            <p style={{ textAlign: 'center' }}>
              <strong>Rejection Reason:</strong> {rejectionReason}
            </p>
          </Grid>
        )}
        <Grid item xs={12} sm={12} md={12}>
          <ButtonInc
            onClick={handleReconfirmClaim}
            hasPermision={hasAuthourity('APPROVE_CLAIM')}
            loading={props.loading && toggleLoading === 'btn1'}
            variant="contained"
            style={{
              width: '221px',
              height: '55px',
              float: 'left',
              marginRight: '20px'
            }}
          >
            Reconfirm Claim
          </ButtonInc>
          <ButtonInc
            onClick={handleConfirmRejection}
            hasPermision={hasAuthourity('REJECT_CLAIM')}
            loading={props.loading && toggleLoading === 'btn2'}
            variant="contained"
            style={{ width: '221px', height: '55px', background: '#8F191C' }}
          >
            Confirm Rejection
          </ButtonInc>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <p style={{ color: 'red' }}>
            {props.error ? props.error.message : ''}
          </p>
        </Grid>
      </Grid>
    </section>
  )
}

export default RejectedPending
